jQuery(document).ready(function($){
	initRetinaCover();
	initSlickSlider();
	initMobileNav();
	initAccordion();
	initCount()
});

function initRetinaCover() {
	jQuery('.bg-stretch').retinaCover();
}

// slick slider init
function initSlickSlider() {
	jQuery('.insta-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		swipeToSlide: true,
		infinite: true,

		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
			}
		}
		]
	});

	jQuery('.testimonial-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		infinite: true,
		dots: true
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener'
	});

	jQuery('.dropdown-menu > a').click(function(e){
		jQuery(this).parents('.dropdown-menu').toggleClass('drop-active');
	});
}

// accordion menu init
function initAccordion() {
	jQuery('.footer-cols').slideAccordion({
		opener: 'h5',
		slider: '.footer-links',
		animSpeed: 300
	});
}

// counter input
function initCount() {
    var minVal = 1, maxVal = 100;

    $(".increaseQty").on('click', function(){
        var $parentElm = $(this).parents(".qtySelector");
        $(this).addClass("clicked");
        setTimeout(function(){
            $(".clicked").removeClass("clicked");
        },100);
        var value = $parentElm.find(".qtyValue").val();
        if (value < maxVal) {
            value++;
        }
        $parentElm.find(".qtyValue").val(value);
    });

    $(".decreaseQty").on('click', function(){
        var $parentElm = $(this).parents(".qtySelector");
        $(this).addClass("clicked");
        setTimeout(function(){
            $(".clicked").removeClass("clicked");
        },100);
        var value = $parentElm.find(".qtyValue").val();
        if (value > 1) {
            value--;
        }
        $parentElm.find(".qtyValue").val(value);
    });
}